import React from "react";
import { ViewStyle } from "react-native";
import {
  LeftRightStyle,
  Message,
  MessageProps,
} from "react-native-gifted-chat";
import { FormattedChatMessage } from "../../app/types";

const GiftedChatMessage = (props: MessageProps<FormattedChatMessage>) => (
  <div className="messageWrapper">
    <Message
      {...props}
      // renderDay={() => <Text>Date</Text>}
      containerStyle={style}
    />
  </div>
);

const style: LeftRightStyle<ViewStyle> = {
  left: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginLeft: 2,
    marginRight: 0,
  },
  right: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "flex-start",
    marginLeft: 2,
    marginRight: 0,
  },
};

export default GiftedChatMessage;
